import { jobLists } from "character";
import NoCharacter from "components/no-character/NoCharacter";
import { RelicData } from "enums";
import manager from "managers/app";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentOptions from "views/page-parts/content/content-options/ContentOptions";
import OverallTable from "views/page-parts/content/overall-table/OverallTable";
import { ViewWeaponPhantomOverallProps } from "views/relics/weapons/phantom/overall/types";
import "./WeaponPhantomOverall.css";

const mapStateToProps = (state:AppState):ViewWeaponPhantomOverallProps => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
	};
};

class WeaponPhantomOverall extends Component<ViewWeaponPhantomOverallProps> {
	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		return (
			<div id="weapon-phantom-overall" className="relic">
				<h1>{t.t("Overall")}</h1>
				<div className="options">
					<ContentOptions jobs={jobLists.relic[RelicData.Group.WEAPON_PHANTOM]} relic={RelicData.Group.WEAPON_PHANTOM} />
				</div>
				<OverallTable relicType={RelicData.Type.WEAPON} relic={RelicData.Group.WEAPON_PHANTOM} />
			</div>
		);
	}

	componentDidMount():void{
		manager.view.changeComplete();
	}

}
export default connect(mapStateToProps)(WeaponPhantomOverall);
